import {
  Button,
  Grid,
  MenuItem,
  Paper,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { useEffect, useState } from "react";
import { getUserById, getUserRoles, updateUserData } from "../../services/User";
import InputField from "../../FormComponents/InputField";
import Validation from "../../Validation/SignupValidation";
import ChipSelectingInputField from "../../components/ChipSelectingInputField";
import { useHistory } from "react-router";

const useStyles = makeStyles({
  container: {
    padding: "20px",
  },
  categoryContainer: {
    padding: "10px",
  },
});

const roleDisplayNameMap = {
  ROLE_ADMIN: "Admin",
  MEMBER: "Member",
  WT_BILL_VIEW: "WT Bill View",
  WT_BILL_CREATE: "WT Bill Create",
  WT_BILL_APPROVE: "WT Bill Approve",
  WT_BILL_PAYMENT_UPDATE: "WT Bill Payment Update",
  WT_ITEM_TRANSFER: "WT Item Transfer",
  WT_BILL_DELETE: "WT Bill Delete",
  SALE_PRODUCT_VIEW: "Sale Product View",
  SALE_PRODUCT_CREATE: "Sale Product Create",
  SALE_PRODUCT_UPDATE: "Sale Product Update",
  SALE_PRODUCT_DELETE: "Sale Product Delete",
  SALE_BILL_VIEW: "Sale Bill View",
  SALE_BILL_CREATE: "Sale Bill Create",
  SALE_BILL_APPROVE: "Sale Bill Approve",
  SALE_BILL_DELETE: "Sale Bill Delete",
  SALE_BILL_PAYMENT_UPDATE: "Sale Bill Payment Update",
  SEND_SALE_BILL: "Send Sale Bill",
  PRINT_SALE_BILL: "Print Sale Bill",
  INVENTORY_VIEW: "Inventory View",
  INVENTORY_UPDATE: "Inventory Update",
  INVENTORY_CREATE: "Inventory Create",
  INVENTORY_DELETE: "Inventory Delete",
  IMPORT_STOCK_VIEW: "Import Stock View",
  IMPORT_STOCK_UPDATE: "Import Stock Update",
  IMPORT_STOCK_CREATE: "Import Stock Create",
  IMPORT_STOCK_DELETE: "Import Stock Delete",
  IMPORT_BILL_VIEW: "Import Bill View",
  IMPORT_BILL_UPDATE: "Import Bill Update",
  IMPORT_BILL_CREATE: "Import Bill Create",
  IMPORT_BILL_DELETE: "Import Bill Delete",
  HIGHER_IMPORT_BILL_DELETE: "Higher Import Bill Delete (Wipe)",
  IMPORT_BILL_APPROVE: "Import Bill Approve",
  IMPORT_BILL_PAYMENT_APPROVE: "Import Bill Payment Approve",
  IMPORT_BILL_RETURN_VIEW: "Import Bill Return View",
  IMPORT_BILL_RETURN_UPDATE: "Import Bill Return Update",
  IMPORT_BILL_RETURN_CREATE: "Import Bill Return Create",
  IMPORT_BILL_RETURN_DELETE: "Import Bill Return Delete",
  IMPORT_BILL_RETURN_APPROVE: "Import Bill Return Approve",
  PRODUCT_VIEW: "Product View",
  PRODUCT_UPDATE: "Product Update",
  PRODUCT_CREATE: "Product Create",
  PRODUCT_DELETE: "Product Delete",
  PRODUCTION_VIEW: "Production View",
  PRODUCTION_CREATE: "Production Create",
  PRODUCTION_UPDATE: "Production Update",
  PRODUCTION_DELETE: "Production Delete",
  WAREHOUSE_CREATE: "Warehouse Create",
  WAREHOUSE_VIEW: "Warehouse View",
  WAREHOUSE_UPDATE: "Warehouse Update",
  WAREHOUSE_DELETE: "Warehouse Delete",
  CUSTOMER_VIEW: "Customer View",
  CUSTOMER_CREATE: "Customer Create",
  CUSTOMER_UPDATE: "Customer Update",
  CUSTOMER_DISABLE: "Customer Disable",
  SALESMAN_VIEW: "Salesman View",
  SUB_ORDER_PERSON_CREATE: "Sub Order Person Create",
  SUB_ORDER_PERSON_VIEW: "Sub Order Person View",
  SUB_ORDER_PERSON_EDIT: "Sub Order Person Edit",
  SUB_ORDER_PERSON_DELETE: "Sub Order Person Delete",
  SUB_ORDER_CREATE: "Sub Order Create",
  SUB_ORDER_VIEW: "Sub Order View",
  SUB_ORDER_EDIT: "Sub Order Edit",
  SUB_ORDER_DELETE: "Sub Order Delete",
  HIGHER_SUB_ORDER_DELETE: "Higher Sub Order Delete (Wipe)",
  SUB_ORDER_CRITICAL_MANAGEMENT: "Sub Order Critical Management",
  SUB_ORDER_APPROVAL: "Sub Order Approval",
  SUB_ORDER_SEND_APPROVAL: "Sub Order Send Approval",
  SUB_ORDER_PAYMENT_DELETE: "Sub Order Payment Delete",
  SUB_ORDER_PAYMENT_VIEW: "Sub Order Payment View",
  SUB_ORDER_PAYMENT_CREATE: "Sub Order Payment Create",
  SUB_ORDER_PAYMENT_APPROVE: "Sub Order Payment Approve",
  VIEW_SETTINGS: "View Setttings",
  EDIT_SETTINGS: "Edit Settings",
  ROUTE_VIEW: "Route View",
  ROUTE_CREATE: "Route Create",
  ROUTE_UPDATE: "Route Update",
  ROUTE_DELETE: "Route Delete",
  INVENTORY_PRICE_VIEW: "Inventory Price View",
  INVENTORY_PRICE_CREATE: "Inventory Price Create",
  INVENTORY_PRICE_UPDATE: "Inventory Price Update",
  INVENTORY_PRICE_DELETE: "Inventory Price Delete",
  PRODUCT_PRICE_VIEW: "Product Price View",
  PRODUCT_PRICE_UPDATE: "Product Price Update",
  PRODUCT_PRICE_CREATE: "Product Price Create",
  PRODUCT_PRICE_DELETE: "Product Price Delete",
  PRODUCT_COST_VIEW: "Product Cost View",
  PRODUCT_COST_UPDATE: "Product Cost Update",
  PRODUCT_COST_CREATE: "Product Cost Create",
  PRODUCT_COST_DELETE: "Product Cost Delete",
  MATERIALS_FOR_PRODUCT_VIEW: "Materials For Product View",
  MATERIALS_FOR_PRODUCT_UPDATE: "Materials For Product Update",
  MATERIALS_FOR_PRODUCT_CREATE: "Materials For Product Create",
  MATERIALS_FOR_PRODUCT_DELETE: "Materials For Product Delete",
  REPORT_CREATE: "Report Create",
  REPORT_GENERATE: "Report Generate",
};

function UserEdit({}) {
  const classes = useStyles();
  const history = useHistory();
  const { userId } = useParams();

  const [userData, setUserData] = useState(null);
  const [error, setError] = useState({});
  const [currentRoles, setCurrentRoles] = useState([]);
  const [userRoles, setUserRoles] = useState([]);
  const [userRoleNames, setUserRoleNames] = useState([]);

  useEffect(async () => {
    fetchUserData();
    fetchUserRoleData();
  }, []);

  const fetchUserData = async () => {
    let result = await getUserById(userId);
    console.log(result);
    if (result !== "Something went wrong...") {
      console.log("user Type", result?.userType);
      setUserData({
        user: result.user,
        userType: result.userType,
      });

      const enhancedRoles = result.user.roles.map((role) => ({
        ...role,
        displayName: roleDisplayNameMap[role.roleName] || role.roleName,
      }));

      const currentRoleNames = enhancedRoles.map((role) => role.displayName);
      setCurrentRoles(currentRoleNames);
      console.log("user existing roles", currentRoleNames);
    } else {
      setError({
        ...error,
        userFetchError: "Unable to fetch user data!..",
      });
    }
  };

  const fetchUserRoleData = async () => {
    let result = await getUserRoles();
    console.log(result);
    if (result !== "Something went wrong...") {
      console.log("Step in...");
      const enhancedRoles = result.map((role) => ({
        ...role,
        displayName: roleDisplayNameMap[role.roleName] || role.roleName,
      }));

      const roleNames = enhancedRoles?.map((role) => role.displayName);

      console.log("user roles", roleNames);
      setUserRoleNames(roleNames);
      setUserRoles(enhancedRoles);
    } else {
      setError({
        ...error,
        userRoleFetchError: "Unable to fetch user role data!..",
      });
    }
  };

  const handleChange = (name, val) => {
    resetError();
    if (["userType"].includes(name)) {
      setUserData((prevData) => ({
        ...prevData,
        userType: val,
      }));
      return;
    } else {
      setUserData((prevData) => ({
        ...prevData,
        user: {
          ...prevData.user,
          [name]: val,
        },
      }));
    }
  };

  const resetError = () => {
    setError({});
  };
  const handleFormSubmit = async () => {
    const currentRoleKeys = currentRoles.map((role) => {
      console.log("role", role);
      const matchingRole = userRoles.find((r) => r.displayName === role);
      return matchingRole ? matchingRole.roleName : null;
    });
    const submitUser = {
      userId: userId,
      firstName: userData?.user?.fname,
      lastName: userData?.user?.lname,
      phone: userData?.user?.phone,
      email: userData?.user?.email,
      locked: false,
      roleNames: currentRoleKeys,
    };
    console.log("submit user", submitUser);
    setError(Validation(submitUser));
    console.log("error : ", Validation(submitUser));
    if (Object.keys(Validation(submitUser)).length === 0) {
      let result = await updateUserData(userId, submitUser);
      console.log("result--", result);
      if (result !== "Something went wrong...") {
        history.push("/template/users");
      } else {
        setError({
          ...error,
          userUpdateError: "Unable to update user data!..",
        });
      }
    }
  };

  return (
    <Paper className={classes.container} elevation={8}>
      {!error.userFetchError ? (
        <Stack
          direction="column"
          spacing={2}
          sx={{ padding: 2, maxWidth: 500 }}
        >
          <Typography mt={1} variant="h6">
            {" "}
            Update User{" "}
          </Typography>
          <InputField
            name="fname"
            value={userData?.user?.fname}
            errorMsg={error.firstName}
            onChange={(event, newInputValue) =>
              handleChange(event, newInputValue)
            }
            type="text"
            label="First Name"
          />
          <InputField
            name="lname"
            value={userData?.user?.lname}
            errorMsg={error.lastName}
            onChange={(event, newInputValue) =>
              handleChange(event, newInputValue)
            }
            type="text"
            label="Last Name"
          />
          <TextField
            select
            label="User Type"
            name="userType"
            fullWidth
            size="small"
            disabled={true}
            value={userData?.userType || ""}
            onChange={(e) => handleChange("userType", e.target.value)}
          >
            <MenuItem value="STAFF_USER">STAFF USER</MenuItem>
            <MenuItem value="SALES_PERSON">SALES PERSON</MenuItem>
          </TextField>
          <InputField
            name="phone"
            value={userData?.user?.phone}
            errorMsg={error._phone}
            onChange={(event, newInputValue) =>
              handleChange(event, newInputValue)
            }
            type="text"
            label="Phone Number"
          />
          <InputField
            name="email"
            value={userData?.user?.email}
            errorMsg={error._email}
            onChange={(event, newInputValue) =>
              handleChange(event, newInputValue)
            }
            type="text"
            label="Email"
          />
          {userRoleNames.length > 0 ? (
            <ChipSelectingInputField
              selectedValues={currentRoles}
              setSelectedValues={setCurrentRoles}
              dataSet={userRoleNames}
            />
          ) : null}

          <Button variant="contained" fullWidth onClick={handleFormSubmit}>
            Save
          </Button>
          {error.userUpdateError ? (
            <Typography
              align="left"
              variant="caption"
              style={{
                color: "red",
                fontSize: 16,
                fontWeight: "bold",
                paddingLeft: 40,
              }}
            >
              {error.userUpdateError}
            </Typography>
          ) : null}
        </Stack>
      ) : (
        <Typography
          align="left"
          variant="caption"
          style={{
            color: "red",
            fontSize: 16,
            fontWeight: "bold",
            paddingLeft: 40,
          }}
        >
          {error.userFetchError}
        </Typography>
      )}
    </Paper>
  );
}

export default UserEdit;
